import EventBus from '@/events/EventBus';
import Events from '@/events/Events';

export default function ($matomo) {
  EventBus.$on(Events.VideoStarted, (params) => {
    $matomo.trackEvent('VideoPage', Events.VideoStarted, params.url, 1);
  });
}
